import actionTypes from './action-types';
import { Analytics } from 'packages';

export const setPreferredCurrency = currencyCode => {
    Analytics.trackEvent({
        category: 'Settings',
        action: 'Currency',
        label: currencyCode
    });

    return {
        type: actionTypes.SET_PREFERRED_CURRENCY,
        payload: { currencyCode: currencyCode }
    };
};

export const setCurrencyIfNotChosen = currencyCode => ({
    type: actionTypes.SET_CURRENCY_IF_NOT_CHOSEN,
    payload: { currencyCode: currencyCode }
});
